import Immutable from 'immutable';

import {
  USERCAMPAIGNS_LOADING_SUCCESS,
  USERCAMPAIGNS_START_LOADING,
  USERCAMPAIGNLIST_START_LOADING,
  USERCAMPAIGNLIST_LOADING_SUCCESS,
  USERCAMPAIGNS_LOADING_REJECTED,
  SET_CALENDAR_CURRENT_POSITION,
  SET_NEW_CALENDAR_TESTS,
  SET_HAS_SEEN_CALENDAR_TUTORIAL,
  USERCAMPAIGNLIST_LOADING_ERROR,
  USERCAMPAIGNS_LOADING_ERROR,
} from '../actions/userCampaign';

const initialState = Immutable.fromJS({
  list: [],
  data: {},
  loadingState: 'IDLE',
  listLoadingState: 'IDLE',
});

export default function (state = initialState, action) {
  switch (action.type) {
    case USERCAMPAIGNS_LOADING_SUCCESS:
      return state.set('data', Immutable.fromJS(action.data)).set('loadingState', 'SUCCESS');
    case USERCAMPAIGNS_START_LOADING: {
      return state.set('loadingState', 'PENDING');
    }
    case USERCAMPAIGNS_LOADING_ERROR: {
      return state.set('loadingState', 'ERROR');
    }
    case USERCAMPAIGNLIST_START_LOADING:
      return state.set('listLoadingState', 'PENDING');
    case USERCAMPAIGNLIST_LOADING_SUCCESS:
      return state.set('list', Immutable.fromJS(action.data)).set('listLoadingState', 'SUCCESS');
    case USERCAMPAIGNLIST_LOADING_ERROR:
      return state.set('list', Immutable.fromJS(action.data)).set('listLoadingState', 'REJECTED');
    case USERCAMPAIGNS_LOADING_REJECTED: {
      return state.set('loadingState', 'REJECTED');
    }
    case SET_CALENDAR_CURRENT_POSITION: {
      if (!action.position) {
        return state;
      }

      if (!state.getIn[('data', 'storage')]) {
        return state.setIn(['data', 'storage'], action.newStorage);
      }

      return state.setIn(['data', 'storage', 'currentPosition'], action.position);
    }
    case SET_NEW_CALENDAR_TESTS: {
      if (!action.tests) {
        return state;
      }

      return state.setIn(['data', 'storage', 'tests'], action.tests);
    }
    case SET_HAS_SEEN_CALENDAR_TUTORIAL: {
      const storage = state.getIn(['data', 'storage']);

      if (!storage) {
        return state.setIn(
          ['data', 'storage'],
          Immutable.Map({
            hasSeenTutorial: true,
            currentPosition: action.currentPosition,
            tests: action.tests,
          })
        );
      }

      return state.setIn(['data', 'storage', 'hasSeenTutorial'], true);
    }
    default:
      return state;
  }
}

/* Selectors */
export function getUserCampaign(state) {
  return (state && state.getIn(['userCampaign', 'data'])) || Immutable.Map();
}
export function getUserCampaignList(state) {
  return (state && state.getIn(['userCampaign', 'list'])) || Immutable.Map();
}

export function getUserCampaignLoadingState(state) {
  return (state && state.getIn(['userCampaign', 'loadingState'])) || Immutable.Map();
}

export function getUserCampaignId(state) {
  return (state && state.getIn(['userCampaign', 'data', 'id'])) || null;
}

export function getCampaignLang(state) {
  return (state && state.getIn(['userCampaign', 'data', 'lang'])) || 'IT_it';
}

export function getNoReportText(state) {
  return (state && state.getIn(['userCampaign', 'data', 'noReportText'])) || '';
}

export function getReportStatus(state) {
  return (state && state.getIn(['userCampaign', 'data', 'reportStatus'])) || 'INCOMPLETE';
}

export function getUserCampaign360Range(state) {
  return (state && state.getIn(['userCampaign', 'data', 'range360Num'])) || 5;
}
